import React from 'react'
import {Link} from 'react-router'
import {FormattedMessage} from 'react-intl'
import {connect} from 'react-redux'

const LanguageMenu = ({showLanguageDropdown, toggleLanguageDropdown, langs}) => {

  function createMenuOption(lang) {

      let link = '/' + lang.value + '/search';

      return (<li key={lang.value}>
        <Link to={link}>{lang.label}</Link>
      </li>);
  }

  const LanguageMenuOptions = langs.map(createMenuOption)

  return <li className={`dropdown ${showLanguageDropdown ? 'open' : ''}`} onMouseEnter={toggleLanguageDropdown} onMouseLeave={toggleLanguageDropdown}>
      <a>
          <FormattedMessage id="Lang" defaultMessage="Lang"/>
          <span className="caret"></span>
      </a>
      <ul className="dropdown-menu" style={{zIndex:'2000'}}>
        {LanguageMenuOptions}
      </ul>
  </li>
}


const mapStateToProps = (state) => {
  return {
    langs: state.options.langs,
    showLanguageDropdown: state.show.languageDropdown
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLanguageDropdown: _ => dispatch({type:'toggle_language_dropdown'})
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageMenu)



/** WEBPACK FOOTER **
 ** ./app/components/LanguageMenu.jsx
 **/